import { createStore } from '@stencil/store';

import { AdditionalInsight, ConsumerMarketConfidence } from '../interfaces/interface.consumer-market-confidence';

const initialState = {
  keyFactors: [] as ConsumerMarketConfidence[],
  shouldDisplayKeyFactors: false,
  shouldDisplayDealerListInfo: false,
  shouldDisplayExpectDealership: false,
  shouldDisplayConfidentVehicleHistoryReport: false,
  shouldDisplayAdditionalInsights: false,
  additionalInsights: [] as AdditionalInsight[],
  shouldDisplayPrepareForVisit: false,
};

const { on, onChange, state, reset } = createStore(initialState);
type ConsumerMarketConfidenceState = typeof initialState;

export { initialState, on, onChange, reset, state, ConsumerMarketConfidenceState };
export default state;
